// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"63":"2c2a4cff","151":"942853b5","546":"f7aaca38","793":"56596d26","960":"e9ba3722"}[chunkId] + ".css";
};